import { create } from "zustand";
export const HELP_DATA: any = {
  basic_strategy: {
    title: "Set a Basic Strategy",
    area: "Bot Trading",
    content: ` To set your strategy, you can choose between a custom strategy or a saved strategy. 
    
        A custom strategy allows you to set your own parameters for buying and selling. A saved strategy allows you to use a pre-configured strategy that you have saved previously.
    
        If you are a beginner, we recommend using a custom strategy and setting your risk level and trade frequency. As you become more experienced, you can explore more advanced strategies and set your own parameters for buying and selling.`
  },
  coins_to_trade: {
    title: "Coins To Trade",
    area: "Bot Trading",
    content: `
        The coins to trade are the assets that you want to trade. For example, if you want to trade Bitcoin (BTC) for Ethereum (ETH), then BTC is the base asset and ETH is the quote asset.

        Different coins have different trading pairs and different trading volumes. It is important to choose the right coins to ensure that you have enough liquidity and trading opportunities.
      
        The coins you choose will be used to filter the trading pairs that the bot will trade. The bot will only trade the pairs that match the coins you have selected.`
  },
  quote_asset: {
    title: "Quote Asset",
    area: "Bot Trading",
    content: `
        The quote asset is the asset that you want to trade your base asset for. For example, if you want to trade Bitcoin (BTC) for Ethereum (ETH), then ETH is the quote asset.

        Different coins have different trading pairs and different trading volumes. It is important to choose the right coins to ensure that you have enough liquidity and trading opportunities.
      
        The quote asset you choose will be used to filter the trading pairs that the bot will trade. The bot will only trade the pairs that match the coins you have selected.`
  },
  ticker_interval: {
    title: "Ticker Interval",
    area: "Bot Trading",
    content: `
        The ticker interval is the time interval at which the bot will check for new price data. The bot will use this price data to make trading decisions.

        Different ticker intervals have different trading volumes and different trading opportunities. It is important to choose the right ticker interval to ensure that you have enough liquidity and trading opportunities.
      
        .`
  },
  quo_quest_landing: {
    title: "What is Quo Quest?",
    area: "Unlick",
    content: `
        
Unlock custom strategies by modifying your bots' algo. Embark on a Quest through trading's historic highs and lows.

Navigate levels and stages within specific timeframes. Compete against AI, refine strategies, and experience real-time trading feedback.

Conquer stages to unlock bot features and mods. Learn and experiment in a simulated, game-like trading arena.`
  },
  simulated_bots: {
    title: "What are Simulated Bots?",
    area: "Bot Experimenting",
    content: `
        Simulated bots are bots that are not connected to a real exchange. They are used for experimenting and learning about trading strategies.

        Simulated bots use realtime price data to simulate trading. This allows you to test your strategies without risking real money.

        Simulated bots are a great way to learn about trading and experiment with different strategies.`
  },
  backtest_bots: {
    title: "What are Backtest Bots?",
    area: "Bot Experimenting",
    content: `
        Backtest bots are bots that use historical price data to test your strategies. This allows you to see how your strategies would have performed in the past.

        Backtest bots are a great way to test your strategies and see how they would have performed in different market conditions.

        Backtest bots are a great way to learn about trading and experiment with different strategies.`
  },
  live_bots: {
    title: "What are Live Bots?",
    area: "Bot Trading",
    content: `
        Live bots are bots that are connected to a real exchange. They are used for trading real assets.

        Live bots use realtime price data to make trading decisions. This allows you to trade in real time and make real profits.

        Live bots are a great way to automate your trading and take advantage of market opportunities.`
  },
  buy_rsi: {
    title: "Buy RSI",
    area: "Trading Indicators",
    content: `
    The "Buy RSI" setting configures the bot to initiate a purchase when the Relative Strength Index (RSI) falls below a specified threshold. RSI is a momentum oscillator that measures the magnitude of recent price changes to evaluate overbought or oversold conditions.

    Setting an appropriate "Buy RSI" threshold is crucial for the bot's trading strategy as it dictates the RSI level at which the bot considers the asset undervalued and therefore a good buying opportunity. For instance, if the "Buy RSI" threshold is set to 30, the bot will trigger a buy order whenever the RSI value drops to 30 or lower, indicating that the asset may be oversold and potentially poised for a price increase.
    `
  },
  buy_trade_ratio: {
    // This is a percentage 0 - 100 from your current portfolio total available balance.
    title: "Buy Trade Ratio",
    area: "Trading Strategy",
    content: `
        The buy trade ratio is the percentage of your portfolio that the bot will use to buy the base asset. For example, if you set the buy trade ratio to 50%, the bot will use 50% of your portfolio to buy the base asset.

        The buy trade ratio is a key parameter in the bot's trading strategy. It determines the percentage of your portfolio that the bot will use to buy the base asset.

        The buy trade ratio is a key parameter in the bot's trading strategy. It determines the percentage of your portfolio that the bot will use to buy the base asset.`
  },
  buy_trade_slots: {
    // This will take the percentage available to trade based on trade ratio and split into slots reserved for trades.
    title: "Buy Trade Slots",
    area: "Trading Strategy",
    content: `
        The buy trade slots is the number of slots that the bot will use to buy the base asset. For example, if you set the buy trade slots to 5, the bot will use 5 slots to buy the base asset.

        The buy trade slots is a key parameter in the bot's trading strategy. It determines the number of slots that the bot will use to buy the base asset.

        The buy trade slots is a key parameter in the bot's trading strategy. It determines the number of slots that the bot will use to buy the base asset.`
  },
  sell_rsi: {
    title: "Sell RSI",
    area: "Trading Indicators",
    content: `
        The "Sell RSI" setting configures the bot to initiate a sale when the Relative Strength Index (RSI) exceeds a specified threshold. RSI is a momentum oscillator that measures the magnitude of recent price changes to evaluate overbought or oversold conditions.

        Setting an appropriate "Sell RSI" threshold is crucial for the bot's trading strategy as it dictates the RSI level at which the bot considers the asset overvalued and therefore a good selling opportunity. For instance, if the "Sell RSI" threshold is set to 70, the bot will trigger a sell order whenever the RSI value rises to 70 or higher, indicating that the asset may be overbought and potentially poised for a price decrease.
        `
  },
  sell_profit_margin: {
    title: "Sell Profit Margin",
    area: "Trading Strategy",
    content: `
        The sell profit margin is the percentage of profit that the bot will use to sell the base asset. For example, if you set the sell profit margin to 5%, the bot will use 5% of your portfolio to sell the base asset.

        The sell profit margin is a key parameter in the bot's trading strategy. It determines the percentage of profit that the bot will use to sell the base asset.

        The sell profit margin is a key parameter in the bot's trading strategy. It determines the percentage of profit that the bot will use to sell the base asset.`
  },
  sell_stop_loss: {
    title: "Stop Loss",
    area: "Trading Strategy",
    content: `
        The stop loss is a sell order that is triggered when the price of the asset falls below a specified threshold. The stop loss is used to limit the loss on a trade.

        Setting an appropriate stop loss threshold is crucial for the bot's trading strategy as it dictates the price level at which the bot will cut its losses and sell the asset. For instance, if the stop loss threshold is set to 5%, the bot will trigger a sell order whenever the price of the asset falls by 5% or more, limiting the loss on the trade.`
  },
  strategy_overview: {
    title: "Strategy Overview",
    area: "Strategy Basics",
    content: `
      Start with setting your trading strategy. You can opt for a custom strategy, tailoring your own parameters for buying and selling, or choose a pre-saved strategy. Beginners should start with a custom strategy to adjust risk level and trade frequency, gradually moving to more complex strategies with experience.
    `
  },
  trading_assets: {
    title: "Selecting Your Trading Assets",
    area: "Asset Selection",
    content: `
      Your trading strategy revolves around the coins you wish to trade. Consider market volatility, liquidity, and trading volume when selecting your assets. The bot will focus on trading pairs matching your chosen coins, optimizing your opportunities in the market.
    `
  },
  market_analysis: {
    title: "Understanding Market Dynamics",
    area: "Market Analysis",
    content: `
      Analyze market conditions with tools like the RSI (Relative Strength Index) to make informed buy or sell decisions. Lower RSI indicates potential buy opportunities, while a higher RSI suggests it might be time to sell. Adjust your strategy with backtesting and simulated trading to refine your approach without financial risk.
    `
  },
  trading_parameters: {
    title: "Setting Trading Parameters",
    area: "Trading Parameters",
    content: `
      Customize your trading approach with parameters like ticker interval, trade ratio, and trade slots. Ticker interval choice impacts market opportunity and risk—short intervals offer high volatility and potential returns, while longer intervals provide stability. Trade ratio and slots determine how much of your portfolio is allocated to each trade, balancing potential profit against risk.
    `
  },
  risk_management: {
    title: "Risk Management",
    area: "Risk Management",
    content: `
      Essential to any trading strategy is setting a sell profit margin and a stop loss to protect your investments. The sell profit margin dictates the minimum profit for selling a position, whereas stop loss limits potential losses by setting a sell trigger if asset prices fall by a certain percentage.
    `
  },
  educational_features: {
    title: "Educational Features",
    area: "Learning Tools",
    content: `
      Engage with features like Quo Quest to navigate through trading scenarios and compete against AI, or utilize simulated and backtest bots to experiment with strategies safely. These tools offer practical experience and feedback, enhancing your trading skills in a controlled environment.
    `
  },
  leverage_trading: {
    title: "Leverage Trading",
    area: "Advanced Trading Strategies",
    content: `
        Leverage trading involves borrowing funds to increase the potential return of an investment. In bot trading, leverage can amplify both gains and losses. 

        When setting up a bot for leverage trading, it's crucial to understand the risks and rewards. Proper risk management strategies, such as setting tighter stop losses or lower leverage ratios, are essential to mitigate potential losses.

        Leverage trading is not recommended for beginners due to its high-risk nature.`
  },
  technical_analysis: {
    title: "Technical Analysis",
    area: "Trading Indicators and Analysis",
    content: `
        Technical analysis involves analyzing statistical trends gathered from trading activity, such as price movement and volume. It helps traders make informed decisions based on past market performance.

        Key tools in technical analysis include trend indicators, momentum indicators, and volume indicators. Integrating these tools into your bot's strategy can enhance its decision-making process, allowing for more nuanced trading strategies.

        Understanding the basics of technical analysis is crucial for any trader looking to develop sophisticated trading bots.`
  },
  portfolio_diversification: {
    title: "Portfolio Diversification",
    area: "Risk Management",
    content: `
        Portfolio diversification is a risk management strategy that involves spreading investments across various financial instruments, industries, and other categories to reduce exposure to any single asset or risk.

        In bot trading, diversification can be achieved by trading multiple assets, using different strategies, or allocating investments across various trading pairs. This approach helps in mitigating risk and can lead to more stable returns over time.

        Diversification strategies should be considered carefully based on your risk tolerance and trading objectives.`
  },
  algorithm_optimization: {
    title: "Algorithm Optimization",
    area: "Bot Experimenting",
    content: `
        Algorithm optimization involves fine-tuning your trading bot's parameters to improve its performance. This can include adjusting trade frequencies, modifying entry and exit strategies, or optimizing risk management techniques.

        Techniques such as backtesting and forward testing are essential for evaluating the effectiveness of any changes. Additionally, machine learning models can be employed to adapt strategies based on market conditions dynamically.

        Continuous optimization is key to maintaining a competitive edge in algorithmic trading.`
  },
  api_integration: {
    title: "API Integration",
    area: "Technical Setup",
    content: `
        API integration allows your trading bot to communicate directly with cryptocurrency exchanges to fetch real-time data, execute trades, and manage orders seamlessly.

        Securely configuring API keys and understanding rate limits imposed by exchanges are critical steps in setting up your bot. It's also important to implement error handling and reconnection logic to manage downtime or disconnections.

        Proper API integration is crucial for the reliability and efficiency of your trading bot.`
  },
  sentiment_analysis: {
    title: "Sentiment Analysis",
    area: "Market Analysis",
    content: `
        Sentiment analysis involves evaluating the overall sentiment of the market or a specific asset by analyzing various sources of information, such as news articles, social media posts, and market indicators.

        Incorporating sentiment analysis into your trading bot can provide insights into potential market movements driven by trader emotions and public perception.

        While sentiment analysis can be a powerful tool, it should be used in conjunction with other analysis methods to inform trading decisions.`
  },
  security_practices: {
    title: "Security Practices",
    area: "Bot Trading",
    content: `
        Ensuring the security of your trading bot and your investment capital is paramount. This includes safeguarding API keys, using secure and encrypted communication, and implementing robust error checking and logging practices.

        Regularly updating your bot's software, using two-factor authentication for exchanges, and keeping your trading strategies confidential are also essential practices.

        Adopting strong security measures can protect against unauthorized access and potential financial loss.`
  },
  performance_tracking: {
    title: "Performance Tracking",
    area: "Strategy Optimization",
    content: `
        Tracking the performance of your trading bot is crucial for understanding its effectiveness and identifying areas for improvement. This involves monitoring metrics such as profitability, win/loss ratio, drawdown, and volatility.

        Tools and platforms that offer detailed analytics and reporting can help in analyzing your bot's performance over different market conditions.

        Regular performance reviews are essential to refine your trading strategies and achieve long-term success.`
  },
  regulatory_compliance: {
    title: "Regulatory Compliance",
    area: "Legal and Regulatory",
    content: `
        Staying informed about and compliant with regulatory requirements is crucial for traders using bots. This includes understanding the legal implications of automated trading in your jurisdiction and ensuring that your trading activities do not violate any laws or regulations.

        Regulations may involve reporting earnings, paying taxes on gains, and adhering to specific trading practices. Non-compliance can result in penalties or legal action.

        It's advisable to consult with legal experts to ensure that your trading bot operates within legal boundaries.`
  },
  community_engagement: {
    title: "Community Engagement",
    area: "Learning and Development",
    content: `
        Engaging with the trading bot community can provide valuable insights, strategies, and support. Online forums, social media groups, and trading bot repositories are great places to connect with other developers and traders.

        Sharing experiences and learning from others can accelerate your learning curve and help in avoiding common pitfalls.

        Active community engagement fosters collaboration and innovation, contributing to the overall success of your trading endeavors.`
  },
  lobbies: {
    title: "Lobbies",
    area: "Competitive Trading",
    content: `
        QuidPro hosts competitive trading Lobbies that allow users to compete against each other to earn cash prizes and a global ranking.

        Users can join Lobbies with different trading objectives and compete against other users in real-time.
    
        Lobbies are a great way to test your trading skills and compete against other users in a fun and engaging environment.
        `
  },
  risk_level: {
    title: "Risk Level",
    area: "Trading Strategy",
    content: `
        The risk level setting is crucial in tailoring the bot's trading strategy to match your risk tolerance. This parameter influences the bot's decision-making process by balancing potential gains against the likelihood of losses.
  
        A higher risk level may lead to strategies that target higher returns but come with increased volatility and potential for significant losses. Conversely, a lower risk level prioritizes capital preservation, focusing on more stable assets and conservative trading moves.
  
        Adjusting the risk level involves considering factors such as market volatility, your financial goals, and your comfort with potential loss scenarios. It's a strategic choice that can significantly impact the bot's performance and your overall trading experience.`
  },
  trading_frequency: {
    title: "Trading Frequency",
    area: "Trading Strategy",
    content: `
        Trading frequency defines how active the bot will be in the market, determining the number of trades executed over a given period. This parameter is essential for aligning the bot's operations with your trading goals and market outlook.
  
        A higher trading frequency can capitalize on short-term market movements, potentially increasing profits but also exposing you to more transaction costs and market risk. On the other hand, a lower frequency aims for long-term opportunities, reducing transaction costs but possibly missing out on short-term gains.
  
        The optimal trading frequency depends on various factors, including market conditions, the specific assets being traded, and your investment strategy. It requires a balance between seizing profitable opportunities and managing risk and costs effectively.`
  },
  custom_trade_strategies: {
    title: "Custom Trade Strategies",
    area: "Trading Strategy",
    content: `
        Custom trade strategies allow you to define unique selling parameters for individual trades. This feature provides granular control over your trading decisions, enabling you to tailor strategies to specific market conditions and asset behaviors.
  
        For example, you can set custom RSI thresholds, profit margins, or stop-loss levels for each trade, optimizing your approach based on the unique characteristics of the assets being traded.
  
        Custom trade strategies are valuable for fine-tuning your trading bot's performance and adapting to dynamic market conditions. They offer flexibility and precision in executing your trading strategies, enhancing your ability to capitalize on diverse market opportunities.`
  },
  live_bot_binance_api: {
    title: "Live Bot Binance API",
    area: "Integration",
    content: `
    Integrating your bot with Binance via API facilitates real-time trading, aligned with your strategies. However, this entails significant risks.

    **Disclaimer:** Using a live trading bot carries the risk of capital loss. You assume full responsibility for any resulting losses, operating the bot at your own risk without cost. Our platform supports the Binance API. Generate and input your Binance API credentials in the bot to start trading, ensuring you maintain full control over your funds. Our service never takes custody of your assets, and you can revoke API access or halt trading anytime.

    Assess the implications of deploying a live bot, considering your financial situation and risk appetite.`
  },
  bot_portfolio: {
    title: "Bot Portfolio",
    area: "Trading Strategy",
    content: `
        Your bot's portfolio represents the assets it holds and the allocation of your investment capital across different trading pairs. It's essential to maintain a balanced and diversified portfolio to manage risk and optimize returns.

        The bot portfolio should align with your trading strategy and risk tolerance, considering factors such as market conditions, asset volatility, and your financial goals.

        Regularly reviewing and adjusting your bot's portfolio is crucial for adapting to changing market dynamics and maintaining a competitive edge in the cryptocurrency market.`
  },
  buy_options: {
    //view insights on coins you track in your bot and manually buy
    title: "Buy Options",
    area: "Trading Strategy",
    content: `
        Buy options allow you to view insights on coins you track in your bot and manually buy.

        You can view insights on coins you track in your bot and manually buy.
    `
  },
  bot_config: {
    title: "Bot Config",
    area: "Bot Configuration",
    content: `
        Bot configuration allows you to customize your bot's settings, including trading parameters, risk management strategies, and asset allocation.

        You can adjust your bot's configuration to align with your trading goals and market outlook, optimizing its performance and adapting to dynamic market conditions.
    `
  },
  bot_trades: {
    title: "Bot Trades",
    area: "Trading Activity",
    content: `
        Bot trades represent the buying and selling activities executed by your trading bot. Monitoring your bot's trades provides insights into its performance and helps in evaluating its effectiveness.

        You can customise your trades further or Sell manually if you click on the trade.

        You can review your bot's trades to understand its decision-making process and identify areas for improvement in your trading strategy.
    `
  }
};

interface helpCenterState {
  isHelpOpen: boolean;
  setIsHelpOpen: (isOpen: boolean) => void;
  activeHelpId: string;
  setActiveHelpId: (helpId: string) => void;
  activeData?: any;
}

export const useHelpStore = create<helpCenterState>(setState => ({
  isHelpOpen: false,
  setIsHelpOpen: (isOpen: boolean) => {
    setState({ isHelpOpen: isOpen });
  },

  activeHelpId: "",
  setActiveHelpId: (helpId: string) => {
    setState({ activeHelpId: helpId, activeData: HELP_DATA[helpId] });
  },
  activeData: HELP_DATA["basic_stragey"]
}));
